import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsErrorCircle = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M13.7071 6.29283C14.0976 6.68336 14.0976 7.31652 13.7071 7.70705L11.4142 9.99994L13.7071 12.2928C14.0976 12.6834 14.0976 13.3165 13.7071 13.707C13.3166 14.0976 12.6834 14.0976 12.2929 13.707L10 11.4142L7.70711 13.707C7.31658 14.0976 6.68342 14.0976 6.29289 13.707C5.90237 13.3165 5.90237 12.6834 6.29289 12.2928L8.58579 9.99994L6.29289 7.70705C5.90237 7.31652 5.90237 6.68336 6.29289 6.29283C6.68342 5.90231 7.31658 5.90231 7.70711 6.29283L10 8.58573L12.2929 6.29283C12.6834 5.90231 13.3166 5.90231 13.7071 6.29283Z"
          fill="inherit"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
          fill="inherit"
        />
      </svg>
    );
  }
);

export default PdsErrorCircle;
